import script from "./edit-feedback-modal.vue?vue&type=script&setup=true&lang=ts"
export * from "./edit-feedback-modal.vue?vue&type=script&setup=true&lang=ts"

import "./edit-feedback-modal.vue?vue&type=style&index=0&id=52af469a&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-52af469a"]])

export default __exports__